import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcMail24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m19.979 5c1.13 0 1.99.909 1.99 1.99v9.038a2.972 2.972 0 0 1 -2.998 2.972h-13.974a2.972 2.972 0 0 1 -2.997-2.972v-9.038c0-1.08.884-1.99 2.014-1.99h15.966zm-15.965 3.218v7.81c0 .54.442.983.983.983h14a.99.99 0 0 0 1.007-.983v-7.761l-5.87 5.847c-.623.62-1.352.98-2.113.98-.737 0-1.434-.317-2.02-.902zm14.418-1.229h-12.822l5.67 5.702c.197.198.469.296.716.296a.879.879 0 0 0 .641-.246l5.794-5.752z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcMail24;
